import {
  IconCalender,
  IconExcel,
  IconFile,
  IconPdf,
  IconWord,
} from '@bbl-digital/snorre-v2'
import { ComponentProps } from 'react'
import { MimeTypeEnum } from 'shared/models/File'

type WithIconProps = ComponentProps<typeof IconFile>

const getFileIcon = (fileType: string, props?: WithIconProps) => {
  if (!fileType) return <IconFile {...props} />
  switch (fileType) {
    case MimeTypeEnum.cal: {
      return <IconCalender {...props} />
    }

    case MimeTypeEnum.xls:
    case MimeTypeEnum.xlsx: {
      return <IconExcel {...props} />
    }

    case MimeTypeEnum.pdf: {
      return <IconPdf {...props} />
    }

    case MimeTypeEnum.doc:
    case MimeTypeEnum.docx: {
      return <IconWord {...props} />
    }

    default:
      return <IconFile {...props} />
  }
}

export { getFileIcon }
